// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__LgdwD","empty":"ModalGraph_empty__2Loe_"};